import { useContext } from 'react';

import { useQuery } from '@apollo/client';

import { AuthContext } from 'auth';
import {
  GET_USER_BY_UUID,
  IGetUserByIdRequest,
  IGetUserByIdResponse,
} from 'schemas';

import { GET_USER_BY_UUID_WITHOUT_TARIFFS } from '../schemas/clients';
import { IGetUserByUUIDHook } from './interfaces';

export const useGetUserByUUID = (
  userUUID: string | undefined | null,
  hidePausableTariff?: boolean
): IGetUserByUUIDHook => {
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const query = hidePausableTariff
    ? GET_USER_BY_UUID_WITHOUT_TARIFFS
    : GET_USER_BY_UUID;

  const { data, loading } = useQuery<IGetUserByIdResponse, IGetUserByIdRequest>(
    query,
    {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
      skip: !userUUID || !permissions?.has('client_info'),
      variables: { uuid: userUUID ?? '' },
    }
  );

  return { data, loading };
};
